import { __assign } from "tslib";
import React from 'react';
import { useBiLogger } from '../hooks/useBiLogger';
export var withLogBiEvent = function (Component) {
    var ComponentWithLogBiEvent = function (props) {
        var logBiEvent = useBiLogger();
        return React.createElement(Component, __assign({}, props, { logBiEvent: logBiEvent }));
    };
    ComponentWithLogBiEvent.displayName = "WithLogBiEvent(".concat(Component.displayName ||
        Component.name ||
        'Component', ")");
    return ComponentWithLogBiEvent;
};
export default withLogBiEvent;
//# sourceMappingURL=withLogBiEvent.js.map